<template>
  <div class="content">
    <div class="list">
      <div
        v-for="(item, index) in list"
        :key="index"
        class="list-item"
        @click="handleInformItem(item)"
      >
        <div class="label">{{ item.infoName }}</div>
        <div class="timer" v-if="item.publishTime">
          {{ item.publishTime.slice(0, 10) }}
        </div>
      </div>
    </div>
    <div class="nav-button" @click="handleInformMore">
      <span>查看更多 >></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModuleInfo',

  props: {
    list: {
      type: Array,
      required: false
    }
  },
  data () {
    return {
    }
  },
  methods: {
    // 通知公告查看单条
    handleInformItem(row) {
      const { id } = row
      this.$emit('toDetail', id)
    },
    // 通知公告查看更多
    handleInformMore() {
      this.$emit('toMore')
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  width: 100%;
  height: 338px;
  overflow-y: auto;
  // 每行
  .list-item {
    width: 100%;
    height: 52px;
    box-sizing: border-box;
    padding-left: 8px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
    position: relative;

    &::before {
      display: block;
      content: '';
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background: #FF4E4E;
      position: absolute;
      top: 50%;
      left: 1px;
      transform: translateY(-50%);
    }

    &:not(:first-child) {
      border-top: 1px dashed #D9D9D9;
    }

    // 文字
    .label {
      width: 0;
      flex: 1;
      margin-right: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 14px;
      color: #2F2F2F;
    }

    // 时间
    .timer {
      font-size: 14px;
      color: #2F2F2F;
    }
  }
}
.nav-button {
  width: 80px;
  height: 20px;
  margin: auto;
  line-height: 20px;
  text-align: left;
  font-size: 14px;
  color: #0861D5;
  cursor: pointer;
}
</style>
